import { SASortObject } from 'types/SearchProvider'
import { SORT_BY_AND_ORDER } from 'lib/constructor/constants/hardcodedSaatchiFilters'
import { CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER } from 'lib/constructor/constants'
import ISO2_GEO_ZONES from 'lib/constants/iso2GeoZones'
import { slugify } from 'lib/slugify'

export const handleScrollToTop = async (callbackFunction?: () => void): Promise<void> => {
  if (window !== undefined) {
    const scrollToTopAndThen = (callback?: () => void) => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      // Use requestAnimationFrame to check if the page has finished scrolling
      const checkScroll = () => {
        // If the scroll position is at the top, execute the next callback
        if (window.scrollY === 0) {
          // Stop the requestAnimationFrame loop and perform the next callback
          callback?.()
        } else {
          // Otherwise, keep checking
          requestAnimationFrame(checkScroll)
        }
      }
      // Start checking if the scroll is complete
      requestAnimationFrame(checkScroll)
    }

    scrollToTopAndThen(callbackFunction)
  }
}

const removeDestinationZoneSuffix = (str: string, destinationZone: string) => {
  const uniqueDestinationZones = Array.from(new Set(Object.values(ISO2_GEO_ZONES)))

  if (Boolean(str) && uniqueDestinationZones.includes(destinationZone)) {
    const destinationZoneToRemove = new RegExp(`-${destinationZone}$`)
    return str.replace(destinationZoneToRemove, '')
  }

  return str
}

export const getSortKeyByValue = (
  value: SASortObject,
  destinationZone: string
): string | undefined => {
  if (!value) {
    return undefined
  }

  const sortByWithoutDestinationZone = removeDestinationZoneSuffix(value.sortBy, destinationZone)

  return (Object.entries(SORT_BY_AND_ORDER).find(([_, sortConfig]) => {
    return (
      sortConfig?.sortBy === sortByWithoutDestinationZone &&
      sortConfig?.sortOrder === value.sortOrder
    )
  }) || [])[0]
}

export const getNormalizedCategoryValueToGroups = (selectedCategory: string): string => {
  const slugifiedSelectedCategory = slugify(selectedCategory)
  const groupIdValue =
    CATEGORY_FROM_FACET_TO_CONSTRUCTOR_GROUP_ID_FILTER[slugifiedSelectedCategory] ||
    slugifiedSelectedCategory

  return groupIdValue
}
